import { render, staticRenderFns } from "./disease_result.vue?vue&type=template&id=aafc0870&scoped=true"
import script from "./disease_result.vue?vue&type=script&lang=js"
export * from "./disease_result.vue?vue&type=script&lang=js"
import style0 from "./disease_result.vue?vue&type=style&index=0&id=aafc0870&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafc0870",
  null
  
)

export default component.exports